import utils from "../utils";
import { events as screenEvents } from '../actions/screen'

export default (previousState, action) => {
    if(previousState) previousState.activeScreen = undefined;

    switch (action.type) {
        case screenEvents.SET_ALL_SLUGS:
            /* sort slugs to have 'id' as key @jkr */
            previousState.allSlugs = [];
            action.state.reverse().forEach((o, i) => {
                o.page = Math.ceil(i / 100);
                previousState.allSlugs[o.id] = o;
            });

            break;
        // case screenEvents.SET_ACTIVE_SCREEN_JSON:
        //     previousState.activeScreen = action.state;
        //     break;
        case screenEvents.SET_ALL_SCREENS_JSON:
            if (!previousState.allScreens) previousState.allScreens = {};

            action.state.forEach(item => {
                if (item.id) {
                    previousState.allScreens[item.id] = item;
                }
            });

            break;
        default: break;
    }

    const m = window.location.pathname.match(/screen\/([a-z0-9_-]+)\/?/i);
    if (previousState && previousState.allScreens && m && m.length) {
        const slug = m[1];
        const allSlugs = previousState.allSlugs;
        const allScreens = previousState.allScreens;
        let info;
        allSlugs.some(o => {
            info = o;
            return o.slug === slug;
        });

        let screen = allScreens[info.id];

        try {
            screen.body = utils.createBodyFromHtml(screen.content.rendered);
            screen.bgImg = utils.ripBigImageFromBody(screen.body);
            // screen.bgImg.src = utils.urlBypassHtpasswd(screen.bgImg.src);
        } catch (e) {
            screen = undefined;
        }

        previousState.activeScreen = screen;
    }

    return { ...previousState }
}